module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider3Pre-ed478084.jpeg";